var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupervisedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2954_26062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43359 4.57959L11.506 2.22363L19.5703 4.57959V9.41073C19.57 11.8866 18.7907 14.2997 17.3429 16.3081C15.8951 18.3165 13.8521 19.8186 11.5033 20.6015C9.15358 19.8189 7.10975 18.3167 5.6614 16.3078C4.21305 14.2989 3.43363 11.8851 3.43359 9.40849V4.57959Z",
    stroke: "white",
    strokeWidth: 0.896483,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46777 10.7402L10.6055 13.8779L15.9844 8.49902",
    stroke: "white",
    strokeWidth: 0.896483,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2954_26062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5156,
    height: 21.5156,
    fill: "white",
    transform: "translate(0.744141 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisedIcon);
export default __webpack_public_path__ + "static/media/supervisedIcon.d5f55a5820430408f64fdb94017b37e0.svg";
export { ForwardRef as ReactComponent };